import type { AnyAction } from "~/app/store/types";
import { isProductPage, isSearchPage } from "~/utils/url/urlUtils";

export const SET_SEARCH_QUERY = "Autosuggest: Set Search Query";

export interface SearchState {
  query: string;
}

const isSrp = isSearchPage();
const isPdp = isProductPage();
const userQuery = new URLSearchParams(window.location.search).get("text") ?? "";

export const initialState: SearchState = {
  query: isSrp || isPdp ? userQuery : "",
};

export const searchQueryReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_SEARCH_QUERY: {
      return {
        ...state,
        query: action.payload,
      };
    }
    default:
      return state;
  }
};
